import { useState, useEffect, useCallback, useContext } from "react";
import "./index.css";
import { FaCrown, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import Loader from "../../components/loader";
import { UserContext } from "../../context/UserContext";
import { apiFetch } from "../../utils/apiFetch";


export default function MindMappingReportList({ setToggle, onClose }) {
  const navigate = useNavigate();
  const { user, loading: userLoading } = useContext(UserContext);
  const isBypassUser = user?.email?.trim().toLowerCase() === "marsmatedemo@gmail.com" || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

  const [reports, setReports] = useState([]);
  const [loadingReports, setLoadingReports] = useState(true);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const handleDeleteConfirm = async () => {
    if (!deleteTargetId) return;
    setDeleting(true);
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/delete-report/${deleteTargetId}`;
    console.log("[DELETE CONFIRM] Fetching URL:", url);
    try {
      const res = await apiFetch(url, {
        method: "DELETE",
      });
      console.log("[DELETE CONFIRM] Response status:", res.status);
      const data = await res.json();
      console.log("[DELETE CONFIRM] Response data:", data);
      if (data.success) {
        setReports(prev => prev.filter(r => String(r.id) !== String(deleteTargetId)));
      } else {
        console.error("[DELETE CONFIRM] Deletion failed:", data.error || data.message);
        alert(`Deletion failed: ${data.error || data.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("[DELETE CONFIRM] Network error during deletion:", err);
      alert(`Network error during deletion: ${err.message}`);
    } finally {
      setDeleting(false);
      setDeleteTargetId(null);
    }
  };

  const fetchReports = useCallback(async (userId) => {
    try {
      const res = await apiFetch(
        `/api/mind-mapping/report-list/${userId}`
      );
      const data = await res.json();
      console.log(data)

      if (data?.success) {
        setReports(data.reports || []);
      } else {
        setReports([]);
      }
    } catch (err) {
      console.error("Error fetching mind mapping reports:", err);
      setReports([]);
    } finally {
      setLoadingReports(false);
    }
  }, []);

  useEffect(() => {
    localStorage.removeItem("mindproButtonActive");
  localStorage.removeItem("mindpremiumButtonActive");
  localStorage.removeItem("proButtonActive");
    localStorage.removeItem("premiumButtonActive");
    if (!userLoading && user?.user_id) {
      fetchReports(user.user_id);
    } else if (!userLoading && !user) {
      setLoadingReports(false);
    }
  }, [user, userLoading, fetchReports]);

  if (userLoading || loadingReports) {
    return (
      <div className="mind-mapping-main-container">
        <Loader />
      </div>
    );
  }

  if (reports.length === 0) {
    return (
      <div className="mind-mapping-main-container">
        <div className="mind-mapping-no-reports">
          No Mind Mapping Reports Generated
        </div>
      </div>
    );
  }
const goToSubscription = (report, type) => {
  setToggle(false);
  onClose();

  localStorage.setItem("mindReports", "true");
  localStorage.setItem("mindpayingReportId",report.id)

  // 🔥 CLEAR ALL OLD FLAGS FIRST
  localStorage.removeItem("mindproButtonActive");
  localStorage.removeItem("mindpremiumButtonActive");

  if (type === "A") {
    localStorage.setItem("mindproButtonActive", "true");
    localStorage.setItem("mindpayingReportType", "A");
  } else {
    localStorage.setItem("mindpremiumButtonActive", "true");
    localStorage.setItem("mindpayingReportType", "B");
  }

  navigate(
    `/report-subscription`,
    { state: { report } }
  );
};


  return (
    <div className="mind-mapping-main-container">
      <div className="mind-mapping-heading-container">
        <button
          className="mind-mapping-back-btn"
          onClick={() => navigate("/dashboard")}
        >
          <FaArrowLeftLong
            size={26}
            onClick={() => {
              onClose();
              setToggle(false);
            }}
          />
        </button>
        <h2 className="mind-mapping-heading">Mind Mapping Reports</h2>
      </div>

      <div className="mind-mapping-list-container">
        {reports.map((report) => {
          const paidReports = report?.paid_reports || [];
          const isPro = paidReports.includes("A");
          const isPremium = paidReports.includes("B");

          return (
            <div className="mind-mapping-card" key={report.id}>
              <div style={{ position: "relative", minHeight: "34px", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px", zIndex: 12 }}>
                <div className="mind-mapping-created-at" style={{ position: "static" }}>
                  Created At:{" "}
                  {new Date(report.created_at).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </div>
                <button 
                  className="mind-mapping-delete-btn" 
                  onClick={() => setDeleteTargetId(report.id)}
                  title="Delete Report"
                >
                  <FaTrash size={12} />
                </button>
              </div>

              {/* REPORT A */}
              <div className="mind-mapping-row">
                <div className="mind-mapping-left">
                  <h3 className="mind-mapping-title">Report A</h3>
                  <div className="mind-mapping-sub-row">
                    <span className="mind-mapping-sub-text">Pro</span>
                    <FaCrown className="mind-mapping-crown silver" />
                  </div>
                </div>

                <div className="mind-mapping-right">
                  {isPro || isBypassUser ? (
                    <button
                      className="mind-mapping-download-btn"
                      onClick={() => {
                        setToggle(false);
                        onClose();
                        navigate(
                          `/mind-mapping-report-a`,
                          { state: { reportData: report } }
                        );
                      }}
                    >
                      Click Here To Download
                    </button>
                  ) : (
                    <button
                      className="mind-mapping-pay-btn"
                      onClick={() => goToSubscription(report, "A")}
                    >
                      Pay ₹ 199/- & See Report
                    </button>
                  )}
                </div>
              </div>

              <hr
                  style={{
                    width: "100%",
                    height: "2px",
                    border: "none",
                    backgroundColor: "#ed5d1a",
                    margin: "20px 0",
                    fontWeight:"bold"
                  }}
                />


              {/* REPORT A+ */}
              <div className="mind-mapping-row">
                <div className="mind-mapping-left">
                  <h3 className="mind-mapping-title">Report A+</h3>
                  <div className="mind-mapping-sub-row">
                    <span className="mind-mapping-sub-text">Premium</span>
                    <FaCrown className="mind-mapping-crown gold" />
                  </div>
                </div>

                <div className="mind-mapping-right">
                  {isPremium || isBypassUser ? (
                    <button
                      className="mind-mapping-download-btn"
                      onClick={() => {
                        setToggle(false);
                        onClose();
                        navigate(
                          `/mind-mapping-report-b`,
                          { state: { reportData: report } }
                        );
                      }}
                    >
                      Click Here To Download
                    </button>
                  ) : (
                    <button
                      className="mind-mapping-pay-btn"
                     onClick={() => goToSubscription(report, "B")}
                    >
                      Pay ₹ 299/-& See Report
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {deleteTargetId && (
        <div className="confirm-delete-overlay">
          <div className="confirm-delete-modal">
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete this report? This action cannot be undone.</p>
            <div className="confirm-delete-actions">
              <button className="confirm-delete-btn" onClick={handleDeleteConfirm} disabled={deleting}>
                {deleting ? "Deleting..." : "Delete"}
              </button>
              <button className="confirm-cancel-btn" onClick={() => setDeleteTargetId(null)} disabled={deleting}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
